module.exports = __webpack_public_path__ + "static/media/jason-liu-resume-online.84bff2ad.pdf";